<script setup>
import { formatShortDate } from '@/lib/utils'

import { formatExpenseMoney } from '@/composables/expense-claim'

const props = defineProps({
  date: {
    type: String,
    required: true,
  },
  total: {
    type: Number,
    required: true,
  },
})
</script>

<template>
  <div class="row items-center justify-between q-px-sm q-pt-sm text-caption text-weight-bold text-uppercase text-grey-7">
    <span>{{ formatShortDate(props.date) }}</span>
    <span>{{ formatExpenseMoney(props.total) }}</span>
  </div>
</template>
